import { ICrudEndpoint } from '@/api/common/CrudEndpoint';
import { ProductCRUD } from '@/api/endpoints/ProductCRUD';
import { EntityType } from '@/store/entityModules/types';
import { ColorCRUD } from '@/api/endpoints/ColorCRUD';
import { CategoryCRUD } from '@/api/endpoints/CategoryCRUD';
import { QuantityBreakCRUD } from '@/api/endpoints/QuantityBreakCRUD';
import { ColorGroupCRUD } from '@/api/endpoints/ColorGroupCRUD';
import { ProductCategoryOptionsCRUD } from '@/api/endpoints/ProductCategoryOptionsCRUD';
import { ProductCategoryAttributesCRUD } from '@/api/endpoints/ProductCategoryAttributesCRUD';
import { ShopifyProductCRUD } from '@/api/endpoints/ShopifyProductCRUD';
import { ProductionTimeCRUD } from '@/api/endpoints/ProductionTimeCRUD';
import { PreorderProductCRUD } from '@/api/endpoints/PreorderProductDRUD';
import { FontCRUD } from '../endpoints/FontCRUD';
import { FontGroupCRUD } from '../endpoints/FontGroupCRUD';

let productClient: ProductCRUD;
let shopifyProductClient: ShopifyProductCRUD;
let colorClient: ColorCRUD;
let categoryClient: CategoryCRUD;
let quantityBreakClient: QuantityBreakCRUD;
let colorGroupClient: ColorGroupCRUD;
let productionTimeClient: ProductionTimeCRUD;
let productCategoryOptionClient: ProductCategoryOptionsCRUD;
let productCategoryAttributeClient: ProductCategoryAttributesCRUD;
let preorderProductClient: PreorderProductCRUD;
let fontClient: FontCRUD;
let fontGroupClient: FontGroupCRUD;

export function getEntityApiClient(entityType: EntityType): ICrudEndpoint<any> {
  switch (entityType) {
    case EntityType.PRODUCT:
      if (!productClient) productClient = new ProductCRUD();
      return productClient;
    case EntityType.COLOR:
      if (!colorClient) colorClient = new ColorCRUD();
      return colorClient;
    case EntityType.CATEGORY:
      if (!categoryClient) categoryClient = new CategoryCRUD();
      return categoryClient;
    case EntityType.QUANTITY_BREAK:
      if (!quantityBreakClient) quantityBreakClient = new QuantityBreakCRUD();
      return quantityBreakClient;
    case EntityType.COLOR_GROUP:
      if (!colorGroupClient) colorGroupClient = new ColorGroupCRUD();
      return colorGroupClient;
    case EntityType.PRODUCT_CATEGORY_OPTION:
      if (!productCategoryOptionClient)
        productCategoryOptionClient = new ProductCategoryOptionsCRUD();
      return productCategoryOptionClient;
    case EntityType.PRODUCT_CATEGORY_ATTRIBUTE:
      if (!productCategoryAttributeClient)
        productCategoryAttributeClient = new ProductCategoryAttributesCRUD();
      return productCategoryAttributeClient;
    case EntityType.SHOPIFY_PRODUCT:
      if (!shopifyProductClient) shopifyProductClient = new ShopifyProductCRUD();
      return shopifyProductClient;
    case EntityType.PRODUCTION_TIME:
      if (!productionTimeClient) productionTimeClient = new ProductionTimeCRUD();
      return productionTimeClient;
    case EntityType.PREORDER_PRODUCT:
      if (!preorderProductClient) preorderProductClient = new PreorderProductCRUD();
      return preorderProductClient;
    case EntityType.FONT:
      if (!fontClient) fontClient = new FontCRUD();
      return fontClient;
    case EntityType.FONT_GROUP:
      if (!fontGroupClient) fontGroupClient = new FontGroupCRUD();
      return fontGroupClient;
    default:
      throw Error(`No matching API client found for ${entityType}!`);
  }
}
